import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";

const SummaryCard = ({ item }) => {
  return (
    <Grid item xs={12} md={4} key={item.id}>
      <Paper
        elevation={0}
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          p: 2.5,
          height: "100%",
          background:
            "linear-gradient(180deg, rgba(25,118,210,0.06) 0%, rgba(25,118,210,0.01) 100%)",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2.5}>
          <Typography
            sx={{
              fontSize: { xs: 46, sm: 60 },
              lineHeight: 1,
              fontWeight: 700,
              minWidth: 70,
              color: "primary.main",
            }}
          >
            {item.value}
          </Typography>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
              {item.label}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
              {item.subLabel}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Grid>
  );
};

export default SummaryCard;
